import IssuePreviewHeader from './IssuePreviewHeader';

export default IssuePreviewHeader;
